import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseAddress'
})
export class ParseAddressPipe implements PipeTransform {

  transform(value: string, requiredData: string[]): any {
    try {
      const address = JSON.parse(value);
      let finalData = '';
      if (requiredData.length) {
        for (const key of requiredData) {
          if (finalData) {
            finalData += ', ' + address[key].toUpperCase();
          } else {
            finalData += address[key];
          }
        }
      }
      return finalData;
    } catch (error) {
        return '';
    }
  }
}
